import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { useMobileNavigation } from "./mobile-navigation-context";
import { MobilePrimaryAction } from "./types";

interface FloatingActionButtonProps {
  action: MobilePrimaryAction;
  /** Collapse to an icon-only button while the user scrolls down a list. */
  compact?: boolean;
}

const FloatingActionButton: React.FC<FloatingActionButtonProps> = ({ action, compact }) => {
  const { hasTabBar } = useMobileNavigation();
  const Icon = action.icon ?? Plus;

  return (
    <motion.button
      type="button"
      layout
      onClick={action.onClick}
      disabled={action.disabled}
      aria-label={action.label}
      whileTap={{ scale: 0.94 }}
      transition={{ type: "spring", stiffness: 500, damping: 35 }}
      className="fixed right-4 z-30 flex h-14 items-center justify-center gap-2 rounded-2xl border-0 bg-primary-600 px-4 text-white shadow-[0_8px_24px_rgba(11,107,207,0.35)] disabled:opacity-50"
      style={{
        bottom: hasTabBar
          ? "calc(4rem + env(safe-area-inset-bottom) + 1rem)"
          : "calc(env(safe-area-inset-bottom) + 1rem)",
        minWidth: "3.5rem",
      }}
    >
      <Icon className="h-5 w-5 shrink-0" />
      <AnimatePresence initial={false}>
        {!compact && (
          <motion.span
            key="label"
            initial={{ opacity: 0, width: 0 }}
            animate={{ opacity: 1, width: "auto" }}
            exit={{ opacity: 0, width: 0 }}
            className="overflow-hidden whitespace-nowrap text-sm font-semibold"
          >
            {action.label}
          </motion.span>
        )}
      </AnimatePresence>
    </motion.button>
  );
};

export default FloatingActionButton;
